
export default { name: "setting-white" };
